import { RankedUser } from "../types/users";
import { Itter } from "../utils/utils";

const users = (name: string) => {
  return Itter<RankedUser>(50, i => ({
    avatar: "",
    color: "",
    displayName: name,
    id: i.toString(),
    level: 1,
    rank: i + 1,
    xp: { season: 0, lifetime: 0 }
  }));
}

export default users

export const xpEnum: Record<number, string> = {
  0: "OFF",
  1: "SILENT",
  2: "FULL"
}